export function isJsonParsable(str: string): boolean {
	try {
		JSON.parse(str);
		return true;
	} catch {
		return false;
	}
}

export function toSnakeCase(input: string): string {
	return input.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

// biome-ignore lint/suspicious/noExplicitAny: ignore
export function snakeCaseKeys<T extends Record<string, any>>(obj: T): T {
	if (Array.isArray(obj)) {
		return obj.map((item) => snakeCaseKeys(item)) as unknown as T;
	} else if (obj !== null && typeof obj === "object") {
		// biome-ignore lint/suspicious/noExplicitAny: ignore
		return Object.keys(obj).reduce<Record<string, any>>((acc, key) => {
			const snakeKey = toSnakeCase(key);
			acc[snakeKey] = snakeCaseKeys(obj[key]);
			return acc;
		}, {}) as T;
	}
	return obj;
}
